import { updateReportAction } from '@aims/shared/redux-store/reports-store';
import useOneM1 from '@aims/shared/shared/use-one-m1';
import useSingleSomethingA10 from '@aims/shared/shared/use-single-something-a10';
import { gql } from '@apollo/client';
import {
  ReportAttachmentAttributes,
  ReportUserLongAttributes,
  ReportUserShortAttributes,
} from '../../reports/constants';

const HolisticQuarterlyReportFullAttributes = gql`
  {
    _id
    quarter
    regionCode
    regionName
    contactId
    contact {
      _id
      fullName
    }
    reportType
    status
    publicAttachments ${ReportAttachmentAttributes}
    privateAttachments ${ReportAttachmentAttributes}
    isSubmitted
    isApproved
    submittedAt
    submittedBy
    submittedByUser ${ReportUserShortAttributes}
    approval {
      status
      when
      approver ${ReportUserLongAttributes}
    }
    notes
    createdBy
    createdByUser ${ReportUserShortAttributes}
    updatedBy
    updatedByUser ${ReportUserShortAttributes}
    createdAt
    updatedAt
    deletedBy
    deletedAt
    holisticProjectId
    holisticProject {
      _id
      projectName
      typeOfProject
    }
    projectCoordId
    projectCoord {
      _id
      fullName
    }
    currency
    exchangeRate
    projectState
    hasReceivedFunds
    loadPaymentsThisQuarterUsd
    loanPaymentsTotalUsd
    loanTotal
    loanTerm
    expensesThisQuarterForeign
    expensesThisQuarterDesc
    revenueThisQuarterForeign
    revenueThisQuarterDesc
    supportedFieldWorkers {
      amountForeign
      contactId
      contact {
        _id
        fullName
      }
      name
    }
    progressDesc
    problemsDesc
    miracles {
      _id
      desc
    }
    prayerRequests {
      _id
      desc
    }
  }
`;

const query = gql`
  query HolisticQuarterlyReportForUser($_id: ID!) {
    holisticQuarterlyReportForUser(_id: $_id) ${HolisticQuarterlyReportFullAttributes}
  }
`;

const extract = (data) => data?.holisticQuarterlyReportForUser;

const HolisticQuarterlyReportUpdateAttributes = gql`
{
  crud
  id
  new ${HolisticQuarterlyReportFullAttributes}
}
`;

export const holisticQuarterlyReportUpdatesSubscription = gql`
  subscription HolisticQuarterlyReportUpdatesForUser($_id: ID!) {
    holisticQuarterlyReportUpdatesForUser(_id: $_id) ${HolisticQuarterlyReportUpdateAttributes}
  }
`;

function useReport(
  _id,
  queryId = 'useHolisticQuarterlyReport',
  showError = true,
) {
  const { loading, refetch } = useOneM1({
    variables: { _id },
    query,
    extract,
    fetchPolicy: 'network-only',
    updateAction: updateReportAction,
    queryId,
    showError,
  });
  const report = useSingleSomethingA10('reports', _id, queryId);

  return {
    report,
    loading,
    refetch,
  };
}

export default useReport;
